import { _axios } from '@/plugins/axios';

const exclaimScorerResource = '/api/v1/exclaim-scoring';

export default {
  generateScores: payload => _axios.post(`${exclaimScorerResource}/score`, payload),
};
